/* หน้าแรกของระบบ — การ์ดกลุ่มงานทั้งหมด */
import { useMemo, useState } from "react";

import { Card, Typography } from "antd";
import {
  AppstoreOutlined,
  ClockCircleOutlined,
  PushpinFilled,
} from "@ant-design/icons";

import { usePermission } from "../../store/context/permission-context";
import { buildGroups } from "../../utils/navGroups";
import Tile from "./Tile";
import TileGrid from "./TileGrid";
import nav from "../../nav";
import { Authenticate } from "../../service/Authenticate.service";
import { getRecent } from "../../utils/recentRecord";
import { getPinned, togglePin } from "../../utils/pinnedMenu";

export default function Modules() {
  const { canView } = usePermission();
  const groups = useMemo(() => buildGroups(canView), [canView]);

  /* ทางลัด 6 เมนูที่เข้าล่าสุด (เก็บใน cookie) — แสดงเฉพาะเมนูที่ยังมีสิทธิ์เห็น */
  const userId = Authenticate().getUserId();
  const recent = getRecent(userId);
  const allowed = useMemo(
    () =>
      new Set(
        groups.flatMap((g) => g.items.filter((i) => i.allowed).map((i) => i.to))
      ),
    [groups]
  );
  const [pinned, setPinned] = useState(() => getPinned(userId));
  const pinnedSet = new Set(pinned.map((p) => p.to));
  const handlePin = (item) => setPinned(togglePin(userId, item));

  const withIcon = (r) => ({
    ...r,
    icon: nav.find((n) => n.to === r.to)?.icon,
  });

  const pinnedItems = pinned.filter((p) => allowed.has(p.to)).map(withIcon);

  const recentItems = recent
    .filter((r) => !pinnedSet.has(r.to))
    .filter((r) => allowed.has(r.to))
    .map(withIcon);

  return (
    <Card
      bordered={false}
      style={{
        margin: 16,
        borderRadius: 16,
        boxShadow: "0 4px 18px rgba(15,23,42,.05)",
      }}
    >
      {pinnedItems.length > 0 ? (
        <div style={{ marginBottom: 28 }}>
          <Typography.Title
            level={5}
            style={{ margin: "0 0 12px", textAlign: "center" }}
          >
            <PushpinFilled style={{ marginRight: 6, color: "#f5a623" }} />
            เมนูปักหมุด
          </Typography.Title>
          <TileGrid>
            {pinnedItems.map((p) => (
              <Tile
                key={p.to}
                icon={p.icon || <PushpinFilled />}
                title={p.title}
                to={p.to}
                state={{ fromPinned: true }}
                pinned
                onTogglePin={() => handlePin(p)}
              />
            ))}
          </TileGrid>
        </div>
      ) : null}

      {recentItems.length > 0 ? (
        <div style={{ marginBottom: 28 }}>
          <Typography.Title
            level={5}
            style={{ margin: "0 0 12px", textAlign: "center" }}
          >
            <ClockCircleOutlined style={{ marginRight: 6 }} />
            เข้าใช้ล่าสุด
          </Typography.Title>
          <TileGrid>
            {recentItems.map((r) => (
              <Tile
                key={r.to}
                icon={r.icon || <ClockCircleOutlined />}
                title={r.title}
                to={r.to}
                state={{ fromRecent: true }}
                pinned={pinnedSet.has(r.to)}
                onTogglePin={() => handlePin(r)}
              />
            ))}
          </TileGrid>
        </div>
      ) : null}

      <Typography.Title
        level={5}
        style={{ marginTop: 0, marginBottom: 2, textAlign: "center" }}
      >
        เมนูระบบ
      </Typography.Title>
      <div
        style={{
          textAlign: "center",
          marginBottom: 14,
          fontSize: 12,
          color: "#94a3b8",
        }}
      >
        เลือกกลุ่มงานที่ต้องการใช้งาน
      </div>
      <TileGrid>
        {groups.map((g) => (
            <Tile
              key={g.key}
              badge={g.code}
              icon={g.items[0]?.icon || <AppstoreOutlined />}
              title={g.title}
              subtitle={`${g.allowedCount}/${g.items.length} เมนู`}
              to={`/modules/${g.key}`}
              disabled={!g.allowed}
            />
        ))}
      </TileGrid>
    </Card>
  );
}
